   class AppConfigService {
       getApiUrl(){
           return "https://agenda-api.dev.doclr.be";
       }
   }
